"use client";

import { UserButton as ClerkUserButton } from "@clerk/nextjs";
import { usePathname } from "next/navigation";
import { PiCoins, PiLink, PiWallet } from "react-icons/pi";

import { EXTERNAL_LINKS } from "@/configs/links.config";
import { PAGES } from "@/configs/pages.config";
import { useUserInfoQuery } from "@/funcs/query/user.query";
import { DEFAULT_LOCALE, getLocaleFromPathname, SupportedLocale } from "@/lib/i18n/locales";
import { withSeoLocalePath } from "@/lib/i18n/seo-paths";
import { cn } from "@/lib/utils";

export default function UserButton(props: { type: "sidebar" | "navigation"; locale?: SupportedLocale }) {
  const { data: userInfo } = useUserInfoQuery();
  const pathname = usePathname();
  const resolvedLocale = props.locale ?? (pathname ? getLocaleFromPathname(pathname) : DEFAULT_LOCALE);
  const pricingPath = withSeoLocalePath(resolvedLocale, PAGES.PRICING.PATH);

  return (
    <ClerkUserButton
      showName={props.type === "sidebar"}
      appearance={
        props.type === "sidebar"
          ? {
              elements: {
                rootBox: "w-full",
                userButtonTrigger:
                  "group h-14 w-full rounded-none justify-start hover:bg-neutral-500 border-t-2 border-b-2 border-black px-[10px] data-[open=true]:bg-primary-100",
                userButtonBox: "gap-1",
                userButtonOuterIdentifier: cn(
                  "order-last text-sm text-white text-nowrap font-semibold transition-opacity duration-300 group-data-[open=true]:text-black"
                ),
              },
            }
          : undefined
      }
    >
      <ClerkUserButton.MenuItems>
        <ClerkUserButton.Link href="/connections/chatgpt" label="ChatGPT connection" labelIcon={<PiLink />} />
        <ClerkUserButton.Link href="/settings/email" label="Email preferences" labelIcon={<PiWallet className="w-4 h-4" />} />
        {userInfo && userInfo.subscription_status !== "free" && (
          <ClerkUserButton.Link
            href={EXTERNAL_LINKS.STRIPE_MANAGE_ACCOUNT}
            label="Manage billing"
            labelIcon={<PiWallet className="w-4 h-4" />}
          />
        )}
        <ClerkUserButton.Link
          href={pricingPath}
          label={userInfo && userInfo.subscription_status !== "free" ? "Purchase credits" : "Upgrade to Pro"}
          labelIcon={<PiCoins className="w-4 h-4" />}
        />
      </ClerkUserButton.MenuItems>
    </ClerkUserButton>
  );
}
